import {memo} from "react";
import {ceil} from "lodash";
import {numberFormat} from "~/utils";
import FontAwesomeIcon from "~/components/FontAwesome";
import DashboardWidgetHeader from "./DashboardWidgetHeader";

/**
 * Xếp hạng doanh thu theo phòng ban cho Dashboard CEO.
 * Dữ liệu: dashboardApi.ceoRevenueByGroup() = [{ groupId, name, total, target }].
 */
const BAR_COLORS = ['#0284c7', '#6366f1', '#f59e0b', '#10b981', '#e11d48', '#8b5cf6'];

function RevenueByGroupWidget({
	items = [],
	loading = false,
	title = 'Doanh thu theo phòng ban',
	icon = 'fa-light fa-ranking-star',
	gradient = 'linear-gradient(135deg, #6366f1 0%, #818cf8 60%, #a5b4fc 100%)',
}) {

	const max = items.reduce((m, it) => Math.max(m, it.total || 0), 0) || 1;

	return (
		<div style={{borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 12px rgba(99,102,241,0.12)', background: '#fff'}}>
			<DashboardWidgetHeader icon={icon} title={title} gradient={gradient} />
			<div style={{padding: '12px 18px'}}>
				{loading && (
					<div style={{textAlign: 'center', padding: '16px 0', color: '#94a3b8', fontSize: 13}}>Đang tải...</div>
				)}

				{!loading && items.length === 0 && (
					<div style={{textAlign: 'center', padding: '20px 0', color: '#94a3b8'}}>
						<FontAwesomeIcon icon={icon} style={{fontSize: 26, display: 'block', marginBottom: 6}} />
						<span style={{fontSize: 12}}>Chưa có dữ liệu doanh thu</span>
					</div>
				)}

				{!loading && items.map((item, index) => {
					const width   = ceil((item.total || 0) / max * 100);
					const percent = item.target > 0 ? ceil((item.total || 0) / item.target * 100) : null;
					const color   = BAR_COLORS[index % BAR_COLORS.length];
					const isLast  = index === items.length - 1;

					return (
						<div key={`group-${item.groupId}`} style={{marginBottom: isLast ? 0 : 14}}>
							<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 5}}>
								<b style={{fontSize: 13, color: '#1e293b'}}>
									<span style={{
										display: 'inline-flex', width: 18, height: 18, borderRadius: '50%',
										background: '#f1f5f9', color: '#64748b', fontSize: 10, fontWeight: 700,
										alignItems: 'center', justifyContent: 'center', marginRight: 8,
									}}>{index + 1}</span>
									{item.name}
								</b>
								<span style={{fontSize: 13, fontWeight: 700, color}}>{numberFormat(item.total)}</span>
							</div>
							<div style={{height: 8, borderRadius: 6, background: '#f1f5f9', overflow: 'hidden'}}>
								<div style={{width: `${width}%`, height: '100%', borderRadius: 6, background: color}} />
							</div>
							{percent !== null && (
								<div style={{fontSize: 11, color: '#94a3b8', marginTop: 3}}>
									Đạt {percent}% cam kết ({numberFormat(item.target)})
								</div>
							)}
						</div>
					);
				})}
			</div>
		</div>
	);
}

export default memo(RevenueByGroupWidget);
